/**
 * [INPUT]: 依赖 clsx 条件展开与 tailwind-merge 冲突消解
 * [OUTPUT]: 对外提供 vendored engine 内部 cn 类名合并函数
 * [POS]: dither-kit 的无业务依赖 class 底座，保持上游引擎内聚
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

/** Tailwind-aware className combiner — local copy so the chart pack is
 * self-contained and portable as a registry. */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
